import constants from "../../../core/constants";

export default function (price) {
  return price / constants.currencyBy;
}



// WEBPACK FOOTER //
// ./src/services/auditorHandler/formatters/price.js